/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCashManagement = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M0 3h24v7h-2V5H2v14h10v2H0zm11 4V6h2v1h3v2h-3v2h1a3 3 0 0 1 2.598 1.5l-1.731 1A1 1 0 0 0 14 13h-1v4H8v-2h3v-2h-1a3 3 0 1 1 0-6zm0 2h-1a1 1 0 0 0 0 2h1zm8.293 3.293a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414L18.414 22H14v-4.414zM16 18.414V20h1.586l4-4L20 14.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCashManagement as CashManagement };
